var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.864,
    height: 17.811,
    viewBox: "0 0 23.864 17.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -64.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.566,76.511a6.785,6.785,0,0,1-2.1-1.544q-.112-.122-.218-.248l-.044.041-2.07.574a4.605,4.605,0,0,0-1.769-3.617A4.877,4.877,0,1,0,0,69.641,13.393,13.393,0,0,0,2.15,76.292a16.694,16.694,0,0,0,6.638,6.335l.227.115.248-.058a19.428,19.428,0,0,0,6.761-3.926c.57-.534,1.109-1.1,1.6-1.649A6.727,6.727,0,0,1,15.566,76.511Z",
    transform: "translate(0 -64.93)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.065 64.962)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.666,67.365a5.364,5.364,0,0,0-3.751-1.736q-.114,0-.227,0a5.4,5.4,0,0,0-.214,10.8c.075,0,.151,0,.226,0a5.4,5.4,0,0,0,3.965-9.059Zm-1.354,3.766a2.619,2.619,0,1,1-.691-1.882A2.6,2.6,0,0,1,288.312,71.131Z",
    transform: "translate(-280.295 -65.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.244 69.141)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M372.078,155.685a1.221,1.221,0,1,0,.322.877A1.213,1.213,0,0,0,372.078,155.685Z",
    transform: "translate(-369.96 -155.292)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.70901375b70cf5f14cad73ac254c35a7.svg";
export { ForwardRef as ReactComponent };